import React from "react";
import * as Styles from "./styles";
import { H1 } from "../../text";
import { NewsContent } from "../news-content";

export const FeaturedNews = ({ data }) => {
  return (
    <Styles.Wrapper
      image={data.leadImage.file.url}
      title={data.title}
      to={`/news/${data.url}`}
    >
      <Styles.Overlay>
        <Styles.Container>
          <H1>{data.title}</H1>
          <NewsContent data={data} />
          <Styles.Button>Read more</Styles.Button>
        </Styles.Container>
      </Styles.Overlay>
    </Styles.Wrapper>
  );
};
